"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgOrgAccessCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zM14.149 8a2.873 2.873 0 01.849 5.617c1.802.361 3.197 1.845 3.294 3.586l.006.194v.284a.32.32 0 01-.246.31l-.073.009h-7.66a.32.32 0 01-.31-.246L10 17.681v-.284c0-1.823 1.431-3.406 3.3-3.78A2.872 2.872 0 0114.149 8zM7.638 9.52c.047 0 .093.01.137.028.069.027.123.07.164.128.04.059.061.123.061.194v4.028c0 .071-.02.136-.06.194a.352.352 0 01-.165.128.352.352 0 01-.138.025.372.372 0 01-.259-.1L6 12.82l-1.378 1.325a.372.372 0 01-.561-.053.331.331 0 01-.061-.194V9.87c0-.07.02-.135.06-.194a.352.352 0 01.165-.128.345.345 0 01.138-.028h3.274zm5.562-5.6l.8 2.4-2.4.4.667-1.166A3.944 3.944 0 006.245 8.7l-.005.203h-.48a4.424 4.424 0 016.745-3.767L13.2 3.92z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgOrgAccessCircle;
exports.default = _default;